import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { loadBodySizes, removeBodySize, updateSts } from './bodySizeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function BodySizeList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const BodySizes = useSelector(
    (state: AppState) => state.BodySizes
  );


  useEffect(() => {
    if (BodySizes.success.sts == true) {
      // if(BodySizes?.success?.data[0]){
      if (BodySizes?.success?.data[0] == 'add' || BodySizes?.success?.data[0] == 'update' || BodySizes?.success?.data[0] == 'delete') {
        dispatch(loadBodySizes());
        // }
        messageApi.open({
          type: 'success',
          content: BodySizes.success.data[1],
        });
      } else {

        messageApi.open({
          type: 'success',
          content: BodySizes.success.data,
        });
      }

      dispatch(updateSts({}));
    } else if (BodySizes.success.sts == false) {
      dispatch(loadBodySizes());
      messageApi.open({
        type: 'error',
        content: BodySizes.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [BodySizes])


  const showModal = (record?: any) => {
    if (record) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeBodySize(id));
    /*  messageApi.open({
       type: 'success',
       content: 'Body Size deleted successfully',
     }); */
  };
  const getNutData = (data: any) => {
    let a: any;
    data.map((e: any, i: any) => {
      a = (a == undefined) ? a = e.nut_name : a + ' , ' + e.nut_name;
    });
    return a;
  }
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={BodySizes.BodySize}
      renderItem={(item: any, index) => (
        <List.Item key={item.bodysize_value}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.bodysize_value)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>

          <div className='main_class'>
            <p className='sub_data'><b>Value:</b> {item.bodysize_value} <br /> <b>Nut:</b> {getNutData(item?.nut)}  </p>
          </div>
        </List.Item>
      )}
    />
  );
}